export default {
    id: "DATA_SCREEN",
    name: "数据看板",
    sort: 88,
    type: "menu"
};
